/* global _ */

Wee.fn.make('newsDetail', {
	init: function() {
		var priv = this.$private;

		priv.initEvents();
		priv.initScreen();
	},
	unload: function() {
		$.events.off(false, '.fixedOnScroll');
		$.screen.reset('toggleShare');
	}
}, {
	_construct: function() {
		this.fixedClass = '-fixed';
		this.lowerShare = 'ref:lowerShare';
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.events.on(window, 'scroll.fixedOnScroll', _.throttle(function(e) {
			scope.addFixedOnScroll('ref:share');
			e.preventDefault();
		}, 125));
	},

	/**
	 * Init screen
	 *
	 * @public
	 */
	initScreen: function() {
		var scope = this;

		$.screen.map([
			{
				min: 3,
				namespace: 'toggleShare',
				callback: function() {
					scope.removeLowerShare();
				}
			},
			{
				max: 2,
				namespace: 'toggleShare',
				callback: function() {
					scope.addLowerShare();
				}
			}
		]);
	},

	/**
	 * Add fixed modifier class to share component
	 *
	 * @private
	 */
	addFixedOnScroll: function(el) {
		var $scroll = Wee.$scrollTop(),
			$bodyHeight = Wee._body.scrollHeight;

		if ($scroll > 480 && $bodyHeight > 2200) {
			Wee.$addClass(el, this.fixedClass);
			this.removeShareOnScroll();
		} else {
			Wee.$removeClass(el, this.fixedClass);
		}
	},

	/**
	 * Add lower share component
	 *
	 * @private
	 */
	addLowerShare: function() {
		$(this.lowerShare).show();
	},

	/**
	 * Remove share on scroll
	 *
	 * @private
	 */
	removeShareOnScroll: function() {
		var bottom = Wee.$scrollTop() + $($._win).height(),
			share = $(this.lowerShare).offset().top,
			$article = $('.-news-article');

		if (bottom >= share) {
			$article.hide();
		} else {
			$article.show();
		}
	},

	/**
	 * Remove lower share component
	 *
	 * @private
	 */
	removeLowerShare: function() {
		if (Wee._body.scrollHeight < 2200) {
			$(this.lowerShare).hide();
		} else {
			$(this.lowerShare).show();
		}
	}
});
